import { Country } from "@/models/country";

interface CountryDataState {
    selectedCountry:Country | null;
    allCountries: any;
}

const initialState: CountryDataState = {
    selectedCountry: null,
    allCountries: []
};

const state: CountryDataState = {
    ...initialState
};

const getters = {
    selectedCountry: (state: CountryDataState) => state.selectedCountry,
    allCountries: (state: CountryDataState) => state.allCountries
};

const mutations = {
    setSelectedCountry(state: CountryDataState, country: Country) {
        state.selectedCountry = country;
    },
    setAllCountries(state: CountryDataState, countries: any) {
        state.allCountries = countries;
    }
};

const actions = {
    setSelectedCountry({ commit }: any, country: Country) {
        commit('setSelectedCountry', country);
    },
    setAllCountries({ commit }: any, countries: any) {
        commit('setAllCountries', countries);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};